import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import {
  isEmptyObject,
  devConsolelog,
  getPrivateApi,
  getDomainValue,
} from "../../Utility";
import {
  API_DOMAIN_B2B2C,
  API_SECTION_B2B2C,
  API_ENDPOINT_WEBSITEPAGES,
  B2B2C_API_PUBLIC_VERSION,
} from "../../Constants";
import NavBar from "./navbar_";
import Footer from "./footer";
import ImageCarousel from "./carousel";
import "../../CKEditorUtility/content-styles.css";
import ReactHtmlParser from "../Commons/ReactHtmlParser";
import { Helmet } from "react-helmet";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    height: "calc(100vh - 80px)",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "auto",
      alignItems: "center",
    },
  },
  contactSection: {
    width: "42%",
    position: "relative",
    padding: theme.spacing(0, 1),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      //  paddingTop:20,
      justifyContent: "space-evenly",
      //  height: 400
      padding: theme.spacing(2, 1),
      paddingBottom: 0,
    },
    height: "100%",
    // display: 'flex',
    // flexDirection: 'column',
    justifyContent: "space-between",
    "&> img": {
      objectFit: "cover",
      minHeight: 300,
    },
  },
  aboutSection: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    //justifyContent: 'space-evenly',
    padding: "50px 10px",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      // height: '60%',
      width: "100%",
      textAlign: "center",
    },
    "& h1": {
      padding: "20px 0",
    },
  },
  paddingText: {
    paddingBottom: 10,
  },
  mainDiv: {
    overflowX: "hidden",
    background: theme.agentTheme.background.main,
  },
  about_us_text: {
    whiteSpace: "pre-wrap",
    color: theme.agentTheme.text.body_text_color,
  },
  title: {
    color: theme.agentTheme.background.primary_text,
    fontSize: "38px",
  },
}));



const AdditionalPages = ({ pageData = null, imageArr = [] }) => {
  const [apiData, setApiData] = useState([]);
  const [data, setData] = useState({});
  const theme = useTheme();
  const [imageData, setImageData] = useState([
    "https://app.travclan.com/media/appcms/About_Us_Page.jpg",
  ]);
  const classes = useStyles();
  const location = useLocation();
  const { slug_url = "" } = useParams();
  let { state = null } = location;
  const domainName = getDomainValue(window.location.hostname);

  let { title = "", text = "", is_advance = false, text_advance = "" } = data;
  console.log(
    "AdditionalPages render",
    location,
    title,
    text,
    imageData,
    data,
    is_advance,
    text_advance
  );

  useEffect(() => {
    if (!domainName) return;
    handlePageData();
  }, [domainName]);

  const handlePageData = () => {
    if (pageData && !isEmptyObject(pageData)) {
      console.log("AdditionalPages pageData ", pageData);
      setData(pageData);
    } else if (state && !isEmptyObject(state)) {
      console.log("AdditionalPages state ", state);
      setData(state);
      if (state.image_url) setImageData([state.image_url]);
    } else {
      console.log("AdditionalPages get Api data ", state);
      getAdditionalPages();
    }
  };

  useEffect(() => {
    if (imageArr && imageArr.length > 0) setImageData(imageArr);
  }, [imageArr]);

  useEffect(() => {
    // getAdditionalPages()
    // if(apiData.length > 0) handleSelectPageData(apiData);
    console.log("AdditionalPages location change ", domainName, data, pageData);
    handlePageData();
  }, [location.pathname]);

  const getAdditionalPages = async () => {
    let { data = {}, err = null } = await getPrivateApi(
      `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_WEBSITEPAGES}?domain_name=${domainName}`
    );
    if (err) {
      // TODO: handle error
      // handleSelectPageData(DUMMY_DATA);
      return;
    }
    let { results = [] } = data;
    setApiData(results);
    handleSelectPageData(results);
  };

  const handleSelectPageData = (apiData = []) => {
    console.log("printing api data", apiData);
    let selectedData = apiData.find((item) => item.slug_url == slug_url) || {};
    console.log("AdditionalPages selectedData", selectedData);
    setData(selectedData);
    if (selectedData.image_url) setImageData([selectedData.image_url]);
  };

  if (!data || isEmptyObject(data)) return null;
  {
    devConsolelog("checking data on line 186", imageData);
  }
  return (
    <div className={classes.mainDiv}>
      <Helmet>
        <title>{title ? title : document.title}</title>
      </Helmet>
      <NavBar nonTransparentNav={true} propClasses={classes} />
      {is_advance ? (
        <Container
          style={{ color: theme.agentTheme.background.primary_text }}
          className="ck-content"
        >
          <ReactHtmlParser data={text_advance} />
        </Container>
      ) : (
        <Container className={classes.container}>
          <div className={`${classes.aboutSection} noScrollbar`}>
            <Typography variant="h1" className={classes.title}>
              {title}
            </Typography>
            {text && (
              <Typography vairant="body1" className={classes.about_us_text}>
                {text || ""}
              </Typography>
            )}
          </div>
          <Container className={classes.contactSection}>
            {imageData && imageData.length > 1 ? (
              <ImageCarousel images={imageData} />
            ) : (
              <img src={imageData[0]} width="100%" height="100%" />
            )}
          </Container>
        </Container>
      )}
      <Footer/>
    </div>
  );
};
// .replace(/(\r\n|\n|\r)/gm, "<br />")
export default AdditionalPages;
